import { faWandMagicSparkles } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { FC } from 'react';
import React from 'react';
import { createPortal } from 'react-dom';

import { RephraseActionKind } from 'src/redux/aiNarrative/types';
import { REPHRASE_ACTIONS } from './constants';
import useClampedLeft from './useClampedLeft';

interface Props {
  top: number;
  left: number;
  placement: 'top' | 'bottom';
  onAction: (action: RephraseActionKind) => void;
}

const RephraseToolbar: FC<Props> = ({ top, left, placement, onAction }) => {
  const { ref, clampedLeft } = useClampedLeft(left);

  return createPortal(
    <div
      ref={ref}
      className={`medium-editor-toolbar medium-editor-toolbar-active ai-rephrase-toolbar ${
        placement === 'top'
          ? 'medium-toolbar-arrow-under'
          : 'medium-toolbar-arrow-over'
      }`}
      style={{
        top,
        left: clampedLeft,
        transform:
          placement === 'top' ? 'translate(-50%, -100%)' : 'translate(-50%, 0)',
      }}
      role="toolbar"
      aria-label="AI rephrase actions"
      data-test-id="ai-rephrase-toolbar"
    >
      <div className="ai-rephrase-toolbar-title">
        <FontAwesomeIcon icon={faWandMagicSparkles} aria-hidden="true" />
        AI Quick actions
      </div>
      <ul>
        {REPHRASE_ACTIONS.map(({ kind, label }) => (
          <li key={kind}>
            <button
              type="button"
              className="medium-editor-action"
              // Keep the editor selection alive while clicking the toolbar
              onMouseDown={e => e.preventDefault()}
              onClick={() => onAction(kind)}
              data-test-id={`ai-rephrase-${kind}`}
            >
              {label}
            </button>
          </li>
        ))}
      </ul>
    </div>,
    document.body,
  );
};

export default RephraseToolbar;
